var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 39520"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4465",
    x: 0.0644531,
    y: 0.611328,
    width: 18.4865,
    height: 38,
    fill: "#23A6BB"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4466",
    x: 18.5508,
    y: 0.611328,
    width: 19.5135,
    height: 38,
    fill: "#C1E6EC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4467",
    x: 18.5508,
    y: 19.0977,
    width: 19.5135,
    height: 19.5135,
    fill: "#D5EDF3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumPlan);
export default __webpack_public_path__ + "static/media/premium_plan.2bdf87d7151c657829609f3045993fe9.svg";
export { ForwardRef as ReactComponent };